<template>
  <el-container class="pages-common pre-tax-index">
    <leftNav />
    <el-main
      class="main-body"
      v-loading="loading"
      element-loading-text="导入中,请稍候"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(238, 238, 238, 0.9)"
    >
      <div class="page-header">
        <div class="title">部门扣款</div>
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          style="display: inline-block"
        >
          <el-form-item label="部门">
            <el-input
              v-model="formInline.dept"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="年度">
            <!-- <el-input
              v-model="formInline.year"
              placeholder="请输入"
              clearable
            ></el-input> -->
            <el-date-picker
              v-model="formInline.year"
              type="year"
              placeholder="选择年"
              value-format="yyyy"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="onSubmit"
              >查询</el-button
            >
            <el-button type="warning" size="small" @click="onReset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <div>
          <el-button size="small" type="primary" @click="exportExcels"
            >导出记录</el-button
          >
        </div>
      </div>
      <div class="page-main">
        <el-table :data="tableData" border stripe size="small" max-height="500">
          <el-table-column
            prop="shouldChargeYear"
            label="年度"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="bigDept" label="部门" align="center">
          </el-table-column>
          <el-table-column
            prop="shouldChargeTotal"
            label="应扣合计"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="realChargeTotal"
            label="实扣合计"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="noChargeTotal" label="未扣余额" align="center">
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import leftNav from "../components/nav.vue";
import rootUrl from "../utils/api";
import { getByDept } from "../api/index";
export default {
  components: {
    leftNav,
  },
  data() {
    return {
      formInline: {},
      currentPage: 1,
      total: 40,
      pageSize: 20,
      tableData: [],
      loading: false,
    };
  },
  mounted() {
    document.title = "部门扣款";
    this.queryList();
  },
  methods: {
    queryList() {
      let data = {
        dept: this.formInline.dept, //部门
        year: this.formInline.year, //年份
        current: this.currentPage, //当前页
        size: this.pageSize, //每页数量
      };
      getByDept(data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.rows;
            // console.log(this.tableData);
            this.total = res.data.total;
          } else {
            this.showMessage("error", res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmit() {
      this.currentPage = 1;
      this.queryList();
    },
    onReset() {
      this.formInline = {};
      this.currentPage = 1;
      this.queryList();
    },
    //导出
    exportExcels() {
      let data = {
        dept: this.formInline.dept ? this.formInline.dept : "", //部门
        year: this.formInline.year ? this.formInline.year : "", //年份
      };

      this.xhr = new XMLHttpRequest();
      this.xhr.open(
        "GET",
        rootUrl +
          "/charge-summary/export-report-by-year-dept" +
          `?dept=${data.dept}&year=${data.year}`,
        true
      );
      this.xhr.responseType = "blob";
      var vmThis = this;
      this.xhr.onload = () => {
        if (this.xhr.status === 200) {
          if (
            this.xhr.response &&
            this.xhr.response.size &&
            this.xhr.response.size > 0
          ) {
            let file = this.xhr.response;
            let fileName = "部门扣款导出.xlsx";
            if ("msSaveOrOpenBlob" in navigator) {
              window.navigator.msSaveOrOpenBlob(file, fileName);
            } else {
              let fileUrl = window.URL.createObjectURL(file);
              let a = document.createElement("a");
              a.download = fileName;
              a.href = fileUrl;
              document.getElementsByTagName("body")[0].appendChild(a);
              a.click();
              a.parentNode.removeChild(a);
              window.URL.revokeObjectURL(fileUrl);
            }
          }
        } else {
          //
        }
      };
      this.xhr.setRequestHeader("token", this.$store.state.loginToken);
      this.xhr.send();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryList();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryList();
      console.log(`当前页: ${val}`);
    },
    showMessage(type, msg) {
      this.$message({
        message: msg,
        type: type,
        duration: 5000,
        center: true,
      });
    },
  },
};
</script>

<style>
.el-date-editor .el-range-separator {
  padding: 0 !important;
  color: #eee;
}
</style>
